/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationQueryKey,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface EventsService {
  /** @summary Search */
  eventsSearch: {
    /** @summary Search */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<EventsSearchSchema, EventsSearchParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<EventsSearchParameters, TMeta, TSignal>,
      client?: (
        schema: EventsSearchSchema,
        options: {
          parameters: EventsSearchParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<EventsSearchData, EventsSearchError>>
    ): Promise<RequestFnResponse<EventsSearchData, EventsSearchError>>;
    /** @summary Search */
    getQueryKey(
      parameters: DeepReadonly<EventsSearchParameters>
    ): ServiceOperationQueryKey<EventsSearchSchema, EventsSearchParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.eventsService.eventsSearch.useQuery({
     *     query: {
     *         employee_id: employeeId,
     *         from_date: fromDate
     *     }
     * })
     * ```
     */
    useQuery<TData = EventsSearchData>(
      parameters:
        | ServiceOperationQueryKey<EventsSearchSchema, EventsSearchParameters>
        | DeepReadonly<EventsSearchParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          EventsSearchData,
          EventsSearchError,
          TData,
          ServiceOperationQueryKey<EventsSearchSchema, EventsSearchParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<EventsSearchError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.eventsService.eventsSearch.useQuery({
     *     query: {
     *         employee_id: employeeId,
     *         from_date: fromDate
     *     }
     * })
     * ```
     */
    useQuery<TData = EventsSearchData>(
      parameters:
        | ServiceOperationQueryKey<EventsSearchSchema, EventsSearchParameters>
        | DeepReadonly<EventsSearchParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          EventsSearchData,
          EventsSearchError,
          TData,
          ServiceOperationQueryKey<EventsSearchSchema, EventsSearchParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<EventsSearchError>>;
    /** @summary Search */
    getInfiniteQueryKey(
      parameters: DeepReadonly<EventsSearchParameters>
    ): ServiceOperationInfiniteQueryKey<EventsSearchSchema, EventsSearchParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.eventsService.eventsSearch.useInfiniteQuery({
     *     query: {
     *         employee_id: employeeId,
     *         from_date: fromDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             employee_id: initialEmployeeId,
     *             from_date: initialFromDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends EventsSearchParameters,
      TQueryFnData = EventsSearchData,
      TData = OperationInfiniteData<TQueryFnData, EventsSearchParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<EventsSearchSchema, EventsSearchParameters>
        | DeepReadonly<EventsSearchParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          EventsSearchError,
          TData,
          ServiceOperationInfiniteQueryKey<EventsSearchSchema, EventsSearchParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<EventsSearchError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.eventsService.eventsSearch.useInfiniteQuery({
     *     query: {
     *         employee_id: employeeId,
     *         from_date: fromDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             employee_id: initialEmployeeId,
     *             from_date: initialFromDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends EventsSearchParameters,
      TQueryFnData = EventsSearchData,
      TData = OperationInfiniteData<TQueryFnData, EventsSearchParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<EventsSearchSchema, EventsSearchParameters>
        | DeepReadonly<EventsSearchParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          EventsSearchError,
          TData,
          ServiceOperationInfiniteQueryKey<EventsSearchSchema, EventsSearchParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<EventsSearchData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<EventsSearchError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const eventsSearchTotal = qraft.eventsService.eventsSearch.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const eventsSearchByParametersTotal = qraft.eventsService.eventsSearch.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             employee_id: employeeId,
     *             from_date: fromDate
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >
        | QueryFiltersByQueryKey<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const eventsSearchResults = qraft.eventsService.eventsSearch.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 employee_id: employeeId1,
     *                 from_date: fromDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 employee_id: employeeId2,
     *                 from_date: fromDate2
     *             }
     *         }
     *     ]
     * });
     * eventsSearchResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const eventsSearchCombinedResults = qraft.eventsService.eventsSearch.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 employee_id: employeeId1,
     *                 from_date: fromDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 employee_id: employeeId2,
     *                 from_date: fromDate2
     *             }
     *         }
     *     ]
     * });
     * eventsSearchCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<EventsSearchSchema, EventsSearchParameters, EventsSearchData, EventsSearchError>
      >,
      TCombinedResult = Array<UseQueryResult<EventsSearchData, EventsSearchError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<EventsSearchData, EventsSearchError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.eventsService.eventsSearch.useSuspenseQuery({
     *     query: {
     *         employee_id: employeeId,
     *         from_date: fromDate
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = EventsSearchData>(
      parameters:
        | ServiceOperationQueryKey<EventsSearchSchema, EventsSearchParameters>
        | DeepReadonly<EventsSearchParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          EventsSearchData,
          EventsSearchError,
          TData,
          ServiceOperationQueryKey<EventsSearchSchema, EventsSearchParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<EventsSearchError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.eventsService.eventsSearch.useSuspenseInfiniteQuery({
     *     query: {
     *         employee_id: employeeId,
     *         from_date: fromDate
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             employee_id: initialEmployeeId,
     *             from_date: initialFromDate
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends EventsSearchParameters, TData = EventsSearchData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<EventsSearchSchema, EventsSearchParameters>
        | DeepReadonly<EventsSearchParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          EventsSearchData,
          EventsSearchError,
          OperationInfiniteData<TData, EventsSearchParameters>,
          ServiceOperationInfiniteQueryKey<EventsSearchSchema, EventsSearchParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<EventsSearchData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, EventsSearchParameters>,
      OperationError<EventsSearchError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const eventsSearchData = qraft.eventsService.eventsSearch.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 employee_id: employeeId1,
     *                 from_date: fromDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 employee_id: employeeId2,
     *                 from_date: fromDate2
     *             }
     *         }
     *     ]
     * });
     * eventsSearchResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const eventsSearchCombinedData = qraft.eventsService.eventsSearch.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 employee_id: employeeId1,
     *                 from_date: fromDate1
     *             }
     *         },
     *         {
     *             query: {
     *                 employee_id: employeeId2,
     *                 from_date: fromDate2
     *             }
     *         }
     *     ]
     * });
     * eventsSearchCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          EventsSearchSchema,
          EventsSearchParameters,
          EventsSearchData,
          EventsSearchError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<EventsSearchData, EventsSearchError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<EventsSearchData, EventsSearchError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Search */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        EventsSearchSchema,
        EventsSearchData,
        EventsSearchParameters,
        EventsSearchError
      >
    ): Promise<EventsSearchData>;
    /** @summary Search */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        EventsSearchSchema,
        EventsSearchData,
        EventsSearchParameters,
        EventsSearchError
      >
    ): Promise<void>;
    /** @summary Search */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        EventsSearchSchema,
        EventsSearchData,
        EventsSearchParameters,
        EventsSearchError
      >
    ): Promise<EventsSearchData>;
    /** @summary Search */
    fetchInfiniteQuery<TPageParam extends EventsSearchParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        EventsSearchSchema,
        EventsSearchData,
        EventsSearchParameters,
        DeepReadonly<TPageParam>,
        EventsSearchError
      >
    ): Promise<OperationInfiniteData<EventsSearchData, EventsSearchParameters>>;
    /** @summary Search */
    prefetchInfiniteQuery<TPageParam extends EventsSearchParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        EventsSearchSchema,
        EventsSearchData,
        EventsSearchParameters,
        DeepReadonly<TPageParam>,
        EventsSearchError
      >
    ): Promise<void>;
    /** @summary Search */
    ensureInfiniteQueryData<TPageParam extends EventsSearchParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        EventsSearchSchema,
        EventsSearchData,
        EventsSearchParameters,
        DeepReadonly<TPageParam>,
        EventsSearchError
      >
    ): Promise<OperationInfiniteData<EventsSearchData, EventsSearchParameters>>;
    /** @summary Search */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<EventsSearchSchema, EventsSearchParameters>
        | DeepReadonly<EventsSearchParameters>
    ): EventsSearchData | undefined;
    /** @summary Search */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<EventsSearchSchema, EventsSearchParameters>
        | DeepReadonly<EventsSearchParameters>
    ): OperationInfiniteData<EventsSearchData, EventsSearchParameters> | undefined;
    /** @summary Search */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >
        | QueryFiltersByQueryKey<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<EventsSearchSchema, EventsSearchParameters>,
            data: NoInfer<OperationInfiniteData<EventsSearchData, EventsSearchParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<EventsSearchSchema, EventsSearchParameters>,
            data: EventsSearchData | undefined,
          ]
        >;
    /** @summary Search */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<EventsSearchSchema, EventsSearchParameters>
        | DeepReadonly<EventsSearchParameters>
    ): QueryState<EventsSearchData, EventsSearchError> | undefined;
    /** @summary Search */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<EventsSearchParameters>
        | ServiceOperationInfiniteQueryKey<EventsSearchSchema, EventsSearchParameters>
    ): QueryState<OperationInfiniteData<EventsSearchData, EventsSearchParameters>, EventsSearchError> | undefined;
    /** @summary Search */
    setQueryData(
      parameters:
        | DeepReadonly<EventsSearchParameters>
        | ServiceOperationQueryKey<EventsSearchSchema, EventsSearchParameters>,
      updater: Updater<NoInfer<EventsSearchData> | undefined, NoInfer<DeepReadonly<EventsSearchData>> | undefined>,
      options?: SetDataOptions
    ): EventsSearchData | undefined;
    /** @summary Search */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<EventsSearchParameters>
        | ServiceOperationInfiniteQueryKey<EventsSearchSchema, EventsSearchParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<EventsSearchData, EventsSearchParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<EventsSearchData, EventsSearchParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<EventsSearchData, EventsSearchParameters> | undefined;
    /** @summary Search */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >
        | QueryFiltersByQueryKey<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >,
      updater: Updater<NoInfer<EventsSearchData> | undefined, NoInfer<EventsSearchData> | undefined>,
      options?: SetDataOptions
    ): Array<EventsSearchData | undefined>;
    /** @summary Search */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        EventsSearchSchema,
        EventsSearchData,
        TInfinite,
        EventsSearchParameters,
        EventsSearchError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Search */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >
        | QueryFiltersByQueryKey<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Search */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >
        | QueryFiltersByQueryKey<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Search */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >
        | QueryFiltersByQueryKey<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >
    ): void;
    /** @summary Search */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >
        | QueryFiltersByQueryKey<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Search */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >
        | QueryFiltersByQueryKey<
            EventsSearchSchema,
            EventsSearchData,
            TInfinite,
            EventsSearchParameters,
            EventsSearchError
          >
    ): number;
    schema: EventsSearchSchema;
    types: {
      parameters: EventsSearchParameters;
      data: EventsSearchData;
      error: EventsSearchError;
    };
  };
}
/** @summary Search */
export const eventsSearch = {
  schema: {
    method: 'get',
    url: '/events/search',
    security: ['HTTPBearer'],
  },
} as {
  schema: EventsSearchSchema;
  [QraftServiceOperationsToken]: EventsService['eventsSearch'];
};
export const eventsService = {
  eventsSearch,
} as const;
type EventsSearchSchema = {
  method: 'get';
  url: '/events/search';
  security: ['HTTPBearer'];
};
type EventsSearchParameters = paths['/events/search']['get']['parameters'];
type EventsSearchData = paths['/events/search']['get']['responses']['200']['content']['application/json'];
type EventsSearchError = paths['/events/search']['get']['responses']['422']['content']['application/json'];
